module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_plan_show_bg_02-8a51de2699bdc12c2bb61d1c30edb106.jpg";